import  FranchiseCard from './FranchiseCard';

export default FranchiseCard